import { Component, OnInit } from '@angular/core';
import { AuthenticationService,FormService,EmployeesService, ProfileService, AlertService,CompanyService} from '../_services/index';
import {Router, ActivatedRoute} from "@angular/router"
@Component({
  selector: 'app-forms',
  templateUrl: './employees.component.html',
  styleUrls: ['./employees.component.scss']
})
export class EmployeesComponent implements OnInit {
  private authorized:any;
  public diseases:any;
  public Employees:any;
  public DiseaseModal:any=false;
  public a:any;
  public list:any=2;
  public tokenForm:any;
  public uri:any;
  public diseaseOne:any={
    name:'',
    description:''
  };
  constructor(
    public profileService: ProfileService,
    public companyService:CompanyService,
    public employeesService:EmployeesService,
    public formService:FormService,
    public alertService:AlertService,
    private router: Router,
    public as: AuthenticationService,
    private route: ActivatedRoute,
  ) { 
    this.authorized = this.as.checkAuthentication();
      if(!this.authorized.authorized){
          this.router.navigate(['/login'])
      }
      this.uri = window.location.protocol+'//'+window.location.hostname;
  }
  ngOnInit() {
    this.getEmployees();
    this.getDisease();
  }
  url(path){
    this.router.navigate([path]);
  }
  changeType(type){
    this.list = type;
  }
  modalStatus(type,data){
    if(type == 'disease'){
      if(this.DiseaseModal){
        this.DiseaseModal = false;
      }else{
        this.DiseaseModal = true;
        if(!data){
          this.diseaseOne={
            name:'',
            description:''
          }
        }else{
          this.getDiseaseOne(data)
        }
      }
    }
  }
  alert(data){
    this.alertService.updateAlert(data).subscribe(()=>{
        setTimeout(() => {
        this.alertService.deleteAlert().subscribe();
        }, 8000);
    })
  }


  getDisease(){
    this.employeesService.getDiseaseList().subscribe(response => {
      this.diseases = response;
    }, error => {
    })
  }
  getDiseaseOne(data){
    this.employeesService.getDiseaseOne(data).subscribe(response => {
        this.diseaseOne = response;
        if(!response){
            this.diseaseOne={
              name:'',
              description:''
            }
            this.alert({reason:'No se ha podido cargar la enfermedad.', type:"danger"});
            this.modalStatus('disease','')
        }
    }, error => {
        this.diseaseOne={
          name:'',
          description:''
        }
        this.alert({reason:'No se ha podido cargar la enfermedad.', type:"danger"});
        this.modalStatus('disease','')
    })
  }
  saveDiseaseOne(data){
    if(data.id){
        this.employeesService.updateDiseaseOne(data).subscribe(response => {
            this.alert({reason:'La enfermedad ha sido actualizada con éxito.', type:"success"});
            this.modalStatus('disease','')
            this.getDisease()
        }, error => {
            this.alert({reason:'No se ha podido actualizar la enfermedad.', type:"danger"});
            this.modalStatus('disease','')
        })
    }else{
        this.employeesService.newDiseaseOne(data).subscribe(response => {
            this.alert({reason:'La enfermedad ha sido creada con éxito.', type:"success"});
            this.modalStatus('disease','')
            this.getDisease()
        }, error => {
            this.modalStatus('disease','')
            this.alert({reason:'No se ha podido guardar la enfermedad.', type:"danger"});
        })
    }
  }
  deleteDiseaseOne(data){
    this.employeesService.deleteDiseaseOne(data).subscribe(response => {
        this.alert({reason:'La enfermedad ha sido eliminada con éxito.', type:"success"});
        this.modalStatus('disease','')
        this.getDisease()
    }, error => {
        this.modalStatus('disease','')
        this.alert({reason:'La enfermedad no ha sido eliminada, intentalo nuevamente.', type:"danger"});
    })
  }


  getEmployees(){
    this.employeesService.getEmployeeList().subscribe(response => {
      var data:any = response;
      if(data){
        if(!data.message){
          this.Employees = response; 
          if(this.Employees.form.token){
            this.tokenForm = JSON.stringify(this.Employees.form.token)
          }
        }
      }
    }, error => {
    })
  }
  
}
